import { FC } from 'react';
import Container from '@mui/material/Container';
import { Card, Box, Grid, Stack, Typography } from '@mui/material';
import "../../index.css"
import SignUpForm from './SignUpForm';

import { Link as RouterLink  } from 'react-router-dom';
import HomeHeader from '../SignIn/HomeHeader';
import loginImage from '../../assets/login-image.png';
/**
 * Sign In form Component. 
 */
const SignUp: FC = () => {
  return (
    <>
    <div  className="blurredBackgroundImage">
    <HomeHeader/>
    </div>
    <Container style={{ marginTop: '35px'}} component="main" maxWidth={false} disableGutters={true}>
      <Box sx={{display:'flex'}}>
            <Box className='box1'>
              <img src={loginImage} width='450px' height='450px'/>
            </Box>
            <Box className='box2'>
              <Card
              className='form-box'
                  // style={{ margin: '0px 0px 0px auto' }}
                  sx={{
                    maxWidth: { xs: 400, lg: 475 },
                    // margin: { xs: 2.5, md: 3 },
                    // '& > *': {
                    //   flexGrow: 1,
                    //   flexBasis: '50%'
                    // }
                  }}
                >
                  <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>
                    <Box>
                      <Grid container direction="column" justifyContent="flex-end">
                        <Grid item xs={12}>
                          <Grid item  xs={12} container justifyContent="center" alignItems="center" >
                            <Grid item>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
                                    <Typography variant="h3">Sign up</Typography>
                                    <Typography component={RouterLink} to="/signin" variant="body1" sx={{ textDecoration: 'none' }} color="primary.light">
                                      Already have an account?
                                    </Typography>
                                  </Stack>
                                </Grid>
                                <Grid item xs={12}>
                                    {/* <SignUpForm /> */}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Card>
            </Box>
      </Box>
    </Container>
    </>
  );
}

export default SignUp;